import { jsx as _jsx } from "react/jsx-runtime";
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import CheckoutButton from 'ui-addon-upgrades/_core/checkout/CheckoutButton';
import MultipleOfferCheckoutButton from '../_core/checkout/MultipleOfferCheckoutButton';
import validateUpgradeData from '../_core/common/data/upgradeData/validateUpgradeData';
import { MARKETING_STARTER, MARKETING_STARTER_EMAIL, GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { getSource } from 'ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySource';
const {
  CHECKOUT
} = sourceKeys;

const UICheckoutButton = props => {
  const {
    offerProductConfigurations,
    nonRecurringProductConfigurations,
    productConfigurations,
    upgradeData
  } = props;
  const isValid = validateUpgradeData(upgradeData);
  const {
    app,
    screen,
    uniqueId,
    upgradeProduct
  } = upgradeData;
  const correctedUpgradeProduct = isValid ? upgradeProduct === MARKETING_STARTER ? MARKETING_STARTER_EMAIL : upgradeProduct : GENERAL;
  const correctedUpgradeData = Object.assign({}, upgradeData, {
    upgradeProduct: correctedUpgradeProduct,
    source: getSource({
      app,
      screen,
      uniqueId
    }, CHECKOUT)
  });
  const correctedProps = Object.assign({}, props, {
    upgradeData: correctedUpgradeData
  });

  if (offerProductConfigurations && nonRecurringProductConfigurations && !productConfigurations) {
    return /*#__PURE__*/_jsx(MultipleOfferCheckoutButton, Object.assign({}, correctedProps));
  }

  return /*#__PURE__*/_jsx(CheckoutButton, Object.assign({}, correctedProps));
};

export default UICheckoutButton;